import React from 'react';
import useTileVersions from '~/hooks/useTileVersions';
import { RailsBlock } from '~/typings/services/rails/tile';

interface Props {
  block: RailsBlock;
  headerType?: 'h1' | 'h2' | 'h3';
}

const TrendingSearchesBlock: React.FC<Props> = ({
  block,
  headerType: Header = 'h2',
}) => {
  const tiles = useTileVersions(block);
  if (tiles.length === 0) {
    return null;
  }

  return (
    <div className="bg-green-100 px-6 py-12">
      <div className="container text-center">
        <Header className="mb-4 text-3xl font-bold">{block.title}</Header>
        <p className="text-grey-600 mb-8">{block.description}</p>

        <div className="flex flex-wrap justify-center gap-3">
          {tiles.map(tile => (
            <a
              key={tile.id}
              href={tile.destination}
              className="border-grey-200 text-grey-700 hover:bg-grey-50 rounded-full border bg-white px-6 py-3 font-medium shadow-sm transition-colors duration-200 hover:shadow-md"
            >
              {tile.button_text || tile.title || tile.name}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TrendingSearchesBlock;
